var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMediumP2Alert = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 140,
    viewBox: "0 0 358 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5911_31236",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 358,
    height: 140
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(42px)",
      clipPath: "url(#bgblur_0_5911_31236_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 84,
    d: "M0 5C0 2.23857 2.23858 0 5 0H353C355.761 0 358 2.23858 358 5V135C358 137.761 355.761 140 353 140H5.00001C2.23858 140 0 137.761 0 135V5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5911_31236)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.95523,
    y: 0.910595,
    width: 152.019,
    height: 194.335,
    rx: 6.5,
    transform: "matrix(0.945183 -0.326542 0.358303 0.933605 241.881 60.57)",
    stroke: "#FFE300",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.13075,
    y: 0.472303,
    width: 150.2,
    height: 196.906,
    rx: 6.5,
    transform: "matrix(0.858731 -0.512427 0.561766 0.827296 228.829 96.0445)",
    stroke: "#FFE300",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 150.679,
    height: 203.367,
    rx: 8,
    transform: "matrix(0.700426 -0.713725 0.759366 0.650664 230.729 125.49)",
    fill: "#FFEC9A"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5911_31236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314 120C327.255 120 338 109.255 338 96C338 82.7452 327.255 72 314 72C300.745 72 290 82.7452 290 96C290 109.255 300.745 120 314 120Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M314 99.8404V96.0004M314 92.1604H314.01M323.6 96.0004C323.6 101.302 319.302 105.6 314 105.6C308.698 105.6 304.4 101.302 304.4 96.0004C304.4 90.6985 308.698 86.4004 314 86.4004C319.302 86.4004 323.6 90.6985 323.6 96.0004Z",
    stroke: "#FF9E00",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5911_31236_clip_path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0 2.23857 2.23858 0 5 0H353C355.761 0 358 2.23858 358 5V135C358 137.761 355.761 140 353 140H5.00001C2.23858 140 0 137.761 0 135V5Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5911_31236",
    x: 278,
    y: 69.6,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.584314 0 0 0 0 0.615686 0 0 0 0 0.647059 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5911_31236"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5911_31236",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMediumP2Alert);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MediumP2Alert.cc96ac19ab04db933f645f87987ec5bb.svg";